/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-04 16:21:40
 *
 *******************************************************/
// @flow

import React from 'react';
import { Prompt } from 'react-router-dom';
import ConfirmLeaveModal from './confirm-leave-modal';
import {
  // exitSABFullscreen,
  enterSABFullscreen
} from 'src/integrations/shopify-app-bridge/fullscreen';

type Props = {
  navigate: Function,
  shouldBlockNavigation: boolean,
  when: boolean,
  isGotoWithoutShowModalConfirm: boolean
};
type State = {
  activeModal: boolean,
  lastLocation: Object,
  confirmedNavigation: boolean
};

class RouteLeavingGuard extends React.Component<Props, State> {
  state = {
    activeModal: false,
    lastLocation: null,
    confirmedNavigation: false
  };

  // Open modal with state
  showModal = (location: Object) => {
    const { isAvailableFullscreen = false } = this.props;
    if (isAvailableFullscreen) {
      enterSABFullscreen();
    }
    this.setState({
      activeModal: true,
      lastLocation: location
    });
  };

  // Close modal and run a call back function
  closeModal = (callback: Function) =>
    this.setState(
      {
        activeModal: false
      },
      callback
    );

  // Handle close modal and navigate
  handleCloseModal = () => {
    this.closeModal(() => {
      const { navigate } = this.props;
      const { lastLocation } = this.state;

      if (lastLocation) {
        this.setState(
          {
            confirmedNavigation: true
          },
          () => {
            // Navigate to the previous blocked location with your navigate function
            navigate(lastLocation.pathname);
          }
        );
      }
    });
  };

  // Handle show modal if blocked navigation
  handleBlockedNavigation = (nextLocation: Object) => {
    const { confirmedNavigation } = this.state;
    const { shouldBlockNavigation, isGotoWithoutShowModalConfirm } = this.props;
    if (isGotoWithoutShowModalConfirm) {
      this.handleConfirmNavigationClickWithoutSaving();
    }
    if (!confirmedNavigation && shouldBlockNavigation) {
      this.showModal(nextLocation);
      return false;
    }

    return true;
  };

  // Handle confirm discard
  handleConfirmNavigationClickWithoutSaving = () => {
    this.handleCloseModal();
  };

  render() {
    const { when } = this.props;
    const { activeModal } = this.state;
    return (
      <React.Fragment>
        <Prompt when={when} message={this.handleBlockedNavigation} />
        <ConfirmLeaveModal
          active={activeModal}
          handleCancel={this.closeModal}
          handleDiscard={this.handleConfirmNavigationClickWithoutSaving}
        />
      </React.Fragment>
    );
  }
}
export default RouteLeavingGuard;
